import { APP_SCOPE } from '@nx/constants';
import { createLogger } from '@nx/logger/legacy';
import { consoleApi, useActiveOrg, useNotifications } from '@nx/state';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { parseErrorResponse } from './helpers';
import { IpFilterSidebar } from './sidebar';
import { IP_FILTERING_ACTION, type IpFilterData } from './types';

const logger = createLogger(APP_SCOPE.aura);

interface CreateIpFilterSidebarProps {
  onClose: () => void;
  canCreate: boolean;
}

export const CreateIpFilterSidebar = ({ onClose, canCreate }: CreateIpFilterSidebarProps) => {
  const { addNotification } = useNotifications();

  const organization = useActiveOrg();

  const [createIpFilter] = consoleApi.useCreateIpFilterMutation();

  const create = (data: IpFilterData): void => {
    if (data.name === undefined || data.name === '') {
      return;
    }

    const requestBody = {
      OrganizationId: organization.id,
      Name: data.name.trim(),
      AllowList: data.allowList ?? [],
      Description: data.description?.trim(),
      Entities: data.filteredEntities,
    };

    createIpFilter(requestBody)
      .unwrap()
      .then((response) => {
        onClose();
      })
      .catch((error: FetchBaseQueryError | SerializedError | undefined) => {
        const errorMessage = parseErrorResponse(error);
        logger.error(errorMessage);

        addNotification({
          type: 'danger',
          title: 'Failed to create IP Filter',
          description: errorMessage,
          timeout: 5000,
        });
      });
  };

  return (
    <>
      <IpFilterSidebar
        onClose={onClose}
        action={IP_FILTERING_ACTION.CREATE}
        hasActionPermission={canCreate}
        onSubmit={create}
      />
    </>
  );
};
